/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  ladas: [],
  tiposVialidades: [],
  estadosGlobales: [],
  bancos: [],
  metodosDePago: [],
  monedas: [],
  permisos: [],
};

export const catalogosSlice = createSlice({
  name: 'catalogos',
  initialState,
  reducers: {
    setLadas: (state, { payload }) => {
      state.ladas = payload;
    },
    setTiposDeVialidades: (state, { payload }) => {
      state.tiposVialidades = payload;
    },
    setEstadosGlobales: (state, { payload }) => {
      state.estadosGlobales = payload;
    },
    setBancos: (state, { payload }) => {
      state.bancos = payload;
    },
    setMetodosDePago: (state, { payload }) => {
      state.metodosDePago = payload;
    },
    setMonedas: (state, { payload }) => {
      state.monedas = payload;
    },
    setPermisos: (state, { payload }) => {
      state.permisos = payload;
    },
    clearCatalogs: (state) => {
      Object.keys(state).forEach((key) => {
        state[key] = initialState[key] || [];
      });
    },
  },
});

export const {
  setLadas,
  setTiposDeVialidades,
  setEstadosGlobales,
  setBancos,
  setMetodosDePago,
  setMonedas,
  setPermisos,
  clearCatalogs,
} = catalogosSlice.actions;

// Data Selectors
export const selectLadas = ({ catalogos }) => catalogos.ladas;
export const selectTiposVialidades = ({ catalogos }) => catalogos.tiposVialidades;
export const selectEstadosGlobales = ({ catalogos }) => catalogos.estadosGlobales;
export const selectBancos = ({ catalogos }) => catalogos.bancos;
export const selectMetodosDePago = ({ catalogos }) => catalogos.metodosDePago;
export const selectMonedas = ({ catalogos }) => catalogos.monedas;
export const selectPermisos = ({ catalogos }) => catalogos.permisos;

export default catalogosSlice.reducer;
